/**
 * Helper class that maintains the types in a list of Queries.
 * This allows the RpcDispatcher to return correctly typed responses.
 */
export class BatchQuery {
    constructor(q) {
        this.queries = [q];
    }
    add(q) {
        this.queries.push(q);
        return this;
    }
    static of(q) {
        return new BatchQuery(q);
    }
}
//# sourceMappingURL=BatchQuery.js.map